import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthApi } from '../../../api'
import { ContentBackdrop } from '../../../components'

const useLogin = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { data, error, loading } = useAuthApi()

  useEffect(() => {
    if (error) {
      navigate(location.pathname + location.search, {
        replace: true, state: { errorStatusCode: 500 },
      })
    }
    if (data) {
      window.location.assign(data.authorizationUrl)
    }
  }, [data, error])

  return { loading }
}

export const AuthPage: React.FC = () => {
  const { loading } = useLogin()

  return loading ? <ContentBackdrop /> : <></>
}
